import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=31bf4eec&scoped=true&lang=html"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
import style0 from "./Order.vue?vue&type=style&index=0&id=31bf4eec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf4eec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bf4eec')) {
      api.createRecord('31bf4eec', component.options)
    } else {
      api.reload('31bf4eec', component.options)
    }
    module.hot.accept("./Order.vue?vue&type=template&id=31bf4eec&scoped=true&lang=html", function () {
      api.rerender('31bf4eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/Order.vue"
export default component.exports